import { useHasAccess } from "./useHasAccess";
import { queries } from "../../shared/queries";
import { useQuery, useZero } from "@rocicorp/zero/react";
import { type ReactNode, useState } from "react";
import { sharedMutators } from "../../shared/mutators";
import { ConfirmModal } from "../components/ConfirmModal";
import { navigate, routes } from "../lib/urls";

export function useDeleteLastBranch(enabled = true) {
  const z = useZero();
  const [pending, setPending] = useState<{
    branchId: string;
    spaceId: string;
  } | null>(null);
  const [branch, branchDetails] = useQuery(
    pending
      ? queries.loadBranchSummary({ branchId: pending.branchId })
      : undefined
  );
  const hasAccess = useHasAccess(
    branch?.name === "main" ? "space:manage" : "space:write",
    pending?.spaceId
  );
  const canDelete = enabled && !!pending && !!branch && hasAccess;
  if (
    pending &&
    (!enabled || (branchDetails.type === "complete" && !canDelete))
  )
    setPending(null);

  const confirm = (branchId: string, spaceId: string) => {
    if (!enabled) return;
    setPending({ branchId, spaceId });
  };

  const modal: ReactNode = (
    <ConfirmModal
      open={pending !== null && canDelete}
      onClose={() => setPending(null)}
      onConfirm={() => {
        if (!pending || !canDelete) return;
        z.mutate(sharedMutators.deleteBranch({ branchId: pending.branchId }));
        const spaceId = pending.spaceId;
        setPending(null);
        navigate(routes.space, { spaceId });
      }}
      title="Delete workflow"
      description="This is the only branch. Deleting it will also delete the workflow."
      confirmLabel="Delete workflow"
      destructive
    />
  );

  return { confirm, modal };
}
